<template>
  <div class="empty-view flex flex-col items-center justify-center flex-1 w-full">
    <img width="180" src="@/assets/common/empty_box.png" alt="" />
    <p v-if="!isHide" class="text-14 empty-text">{{ msg }}</p>
  </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "EmptyPage"
});
</script>

<script setup>
defineProps({
  isHide: {
    type: Boolean,
    default: false
  },
  msg: {
    type: String,
    default: "暂无数据"
  }
});
</script>
<style lang="less" scoped>
.empty-view {
  margin-top: 20px;
  .empty-text {
    color: #959fac;
    margin-top: 5px;
  }
}
</style>
